module.exports = __webpack_public_path__ + "static/media/new-about.774817a3.jpg";